export default function MySQL_CREATETABLE() {
  return (
    <div>
      <h2>MySQL_CREATETABLE</h2>    </div>
  );
}